import React from 'react';
import { CarFrontIcon, RulerIcon } from 'lucide-react';
import { useFunnel } from '../../contexts/FunnelContext';
import type { StringKey } from '../../data/i18n';
import type { CarryBand } from '../../types/funnel';
const bands: {
  value: CarryBand;
  cars: number;
  carKey: StringKey;
}[] = [{
  value: '0_20',
  cars: 1,
  carKey: 'car1'
}, {
  value: '21_40',
  cars: 2,
  carKey: 'car2'
}, {
  value: '41_60',
  cars: 4,
  carKey: 'car4'
}, {
  value: '61_100',
  cars: 6,
  carKey: 'car6'
}, {
  value: 'over_100',
  cars: 8,
  carKey: 'car7'
}, {
  value: 'unsure',
  cars: 0,
  carKey: 'carNone'
}];
export function CarryBandPicker({
  value,
  onChange,
  label
}: {
  value: CarryBand;
  onChange: (v: CarryBand) => void;
  label: string;
}) {
  const {
    t
  } = useFunnel();
  return <fieldset data-id="element-417" data-mp="1sw5556o9cwj1">
      <legend className="text-sm font-semibold text-ink" data-id="element-418" data-mp="1wvnohy0fkzjr">{label}</legend>
      <p className="mb-3 mt-1 text-sm text-ink-500" data-id="element-419" data-mp="1wxgrn3bu51n0">{t('carryHelp')}</p>
      <div role="radiogroup" aria-label={label} className="grid grid-cols-2 gap-2 sm:grid-cols-3" data-id="element-420" data-mp="21vicntstnb14">
        {bands.map(b => {
        const sel = value === b.value;
        return <button key={b.value} type="button" role="radio" aria-checked={sel} onClick={() => onChange(b.value)} className={`flex min-h-[72px] flex-col justify-between rounded-lg border-2 p-3 text-left transition-[border-color,background-color] duration-150 ease-out ${sel ? 'border-ink bg-ink text-white' : 'border-ink-200 bg-white text-ink hover:border-ink-400'}`} data-id="element-421" data-mp="1z6b7ua36xnfd">
              <span className="text-[15px] font-bold" data-id="element-422" data-mp="2d63x00z2jvl8">{t(`cb${b.value}` as StringKey)}</span>
              <span className={`mt-1.5 flex items-center gap-1.5 text-xs ${sel ? 'text-ink-200' : 'text-ink-500'}`} data-id="element-423" data-mp="288u6sj3uvfwc">
                {b.cars > 0 ? <span className="flex" aria-hidden="true" data-id="element-424" data-mp="35p9i8o3um8zi">
                    {Array.from({
                length: Math.min(b.cars, 4)
              }).map((_, i) => <CarFrontIcon key={i} className={`-ml-0.5 h-3.5 w-3.5 first:ml-0 ${sel ? 'text-lime' : ''}`} data-id="element-425" data-mp="yyxuq0voblq9" data-mpi={i} />)}
                  </span> : <RulerIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-426" data-mp="p9weqap4p4ca" />}
                {t(b.carKey)}
              </span>
            </button>;
      })}
      </div>
      <p className="mt-2 text-xs text-ink-500" data-id="element-427" data-mp="fbgo08u0jx3b">{t('carNote')}</p>
    </fieldset>;
}